<div class="row banner task-amend">
  <div class="col">
    <h6 class="pt-5px">
      <strong>
        Configure exit activities
      </strong>
    </h6>
  </div>
  <div class="col">
    <button (click)="createActivity()" class="btn btn-secondary float-end">
      Create new activity
    </button>
  </div>
</div>

<form [formGroup]="activityFilter" class="search">

  <div class="d-flex justify-content-start">
    <div class="m-0 me-3 w-35">
      <ng-select [items]=" exitTypes" formControlName="exitType" bindLabel="displayText"
                 [placeholder]="'Exit type'">
      </ng-select>
    </div>
    <div class="m-0 me-3 w-35">
      <ng-select [items]="exitSubType" formControlName="exitSubType" bindLabel="displayText"
                 [placeholder]="'Exit sub type'" bindValue="id">
      </ng-select>
    </div>

    <div class="m-0 me-3 w-35">
      <ng-select [items]="officeLocation" formControlName="officeLocation" bindLabel="displayText"
                 [placeholder]="'Office location'" bindValue="id">
      </ng-select>
    </div>
    <div class="m-0 me-3 w-35">
      <ng-select [items]="nationalityType" formControlName="nationalityType" bindLabel="displayText"
                 [placeholder]="'Nationality type'" bindValue="id">
      </ng-select>
    </div>

    <div class="m-0 me-3 w-35 d-flex flex-row">
      <button (click)="clearForm()" style="height:29px" eosDebounce class="btn btn-primary ms-2">Clear</button>

      <button (click)="onSubmit()" style="height:29px" eosDebounce [disabled]="!activityFilter.valid"
              class="btn btn-primary ms-2" type="submit">
        Search
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-start check">
    <input type="checkbox" (change)="onChange($event.target.checked)" formControlName="isActive" />
    <div class="txt">Show active only</div>
  </div>
</form>


<div class="d-flex flex-column table-responsive candid-table mt-3 overflow-y-auto" *ngIf="activities.length">
  <table class="table table-bordered table-hover align-middle">
    <thead>
      <tr>
        <th [hidden]="true" scope="col" class=" top-0 bg-light">#</th>
        <th scope="col" class="text-center">
          <a (click)="sort()">
            Order
            <img *ngIf="isAscending"
                 src="design/images/filter.png"
                 class="float-end mt-2 filterimg ps-3" />
            <img *ngIf="!isAscending"
                 src="design/images/filter-up.png"
                 class="float-end mt-2 filterimg ps-3"
                 style="transform: rotateX(180);" />
          </a>
        </th>
        <th scope="col">Exit Activity</th>
        <th scope="col">Type</th>
        <th scope="col" class="text-center">Active/Inactive</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let act of activities; index as i">
        <td [hidden]="true">{{ i + 1 }}</td>
        <td class="text-center">
          <div class="row gx-2">
            <div class="col-lg-4 col-md-4 col-sm-4">
              <input type="number"
                     [(ngModel)]="act.order"
                     class="form-control form-control-sm"
                     [value]="act.order" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
              <button [disabled]="!act.isActive"
                      (click)="updateOrder(act)"
                      eosDebounce
                      class="btn btn-primary btn-sm ms-2"
                      [ngStyle]="{'background-color': act.isActive ? 'grey' : 'rgb(179, 179, 179)'}">
                Update Order
              </button>
            </div>
          </div>
        </td>
        <td>{{ act.header }}</td>
        <td>{{ act.activityTypeString?.displayText || '' }}</td>
        <td class="text-center">
          <div class="d-flex justify-content-center">
            <div *ngIf="act.isActive">Active</div>
            <div *ngIf="!act.isActive">Inactive</div>
          </div>
        </td>
        <td class="text-center">
          <img class="cursor-pointer"
               title="Edit activity"
               (click)="editActivity(act)"
               src="design/images/edit.png" />
        </td>
      </tr>
    </tbody>
  </table>
</div>


<div class="card mt-3 text-center d-flex p-5" *ngIf="!activities.length">
  <div class="card-body">
    No activities found for the given filter values
  </div>
</div>
